<template>
  <section slot='pdf-content'>
    <section class='pdf-item'>
      <img
        src="../../../assets/login-bg.png"
        alt="logo Codet"
        style="width: 55px; height: 55px; background-color: #6A41BD; border-radius: 5px;"
      >
      <!-- <h3 v-if="appointmentDate.length >= 10"> {{ $dateString(appointmentDate) }}</h3> -->
      <h3>(Formato en Desarrollo)</h3>
    </section>
    <!-- <section class='pdf-item'>
      <strong>
        Nombre: <span> Jesus Miguel Corona Lopez </span>
      </strong>
      <strong>
        Nombre: <span> Jesus Miguel Corona Lopez </span>
      </strong>
      <strong>
        Nombre: <span> Jesus Miguel Corona Lopez </span>
      </strong>
    </section> -->
    <!-- Consulta General seccion  -->
    <!-- <section class='pdf-item'>
      <h4>DATOS INFORMATIVOS DEL BENEFICIARIO</h4>
      <h4>CARACTERÍSTICAS DE LA VIVIENDA</h4>
      <h4>CUARTOS DE LA VIVIENDA</h4>
      <h4>SERVICIOS DE LA VIVIENDA</h4>
      <h4>MUEBLES Y ELECTRODOMÉSTICOS</h4>
      <h4>AUTOS</h4>
    </section> -->
    <!-- Consulta General seccion  -->
    <!-- <section class='pdf-item'>
      <h4>ESTRUCTURA FAMILIAR</h4>
      <h4>ESTRUCTURA FAMILIAR EXTENDIDA</h4>
    </section> -->
    <!-- Consulta General seccion  -->
    <!-- <section class='pdf-item'>
      <h4>TOTAL INGRESOS</h4>
      <h4>TOTAL EGRESOS</h4>
      <h4>REMANENTE O DEUDA</h4>
    </section> -->
    <!-- Cualitativo seccion  -->
    <!-- <section class='pdf-item'>
      <h4>CUALITATIVO</h4>
      <h4>PERFIL</h4>
      <h4>CIRUJIA</h4>
    </section> -->
  </section>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$emit('domrendered');
      }, 1000);
    });
  },
};
</script>

<style>
  .pdf-content {
    display: flex;
    justify-content: center;
  }
  h4 {
    color: #161616;
    font-weight: bold;
  }
  .pdf-item {
    border: 1px solid rgb(226, 226, 226);
    border-radius: 12px;
    padding: 12px;
    margin: 5px;
    color: rgb(100, 100, 100);
  }
  .pdf-item:nth-child(1) {
    border: none;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px;
  }
  .pdf-item:nth-child(2) {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
</style>
